import React, {useEffect, useRef} from 'react';
import './ParallaxBar.css';
import bannerImg from '../assets/images/bluete.webp';

/**
 * Bildband mit "Fenster"-Effekt: Auf dem Desktop bleibt das Bild beim Scrollen
 * stehen (background-attachment: fixed). Auf Touch-Geräten, die das nicht
 * unterstützen, wird das Bild beim Scrollen leicht verschoben.
 */
const ParallaxBar = ({height = 420}) => {
  const barRef = useRef(null);

  useEffect(() => {
    const el = barRef.current;
    if (!el) return undefined;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (prefersReducedMotion.matches) return undefined;

    let frameId;

    const updateOffset = () => {
      const rect = el.getBoundingClientRect();
      const offset = (rect.top - window.innerHeight / 2) * 0.25;
      el.style.setProperty('--bg-offset', `${offset}px`);
    };

    const onScroll = () => {
      cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(updateOffset);
    };

    updateOffset();
    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', onScroll);

    return () => {
      cancelAnimationFrame(frameId);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <section className="parallax-fw" aria-hidden="true">
      <div
        ref={barRef}
        className="parallax-bar"
        style={{'--img': `url(${bannerImg})`, '--h': `${height}px`}}
      />
    </section>
  );
};

export default ParallaxBar;
